module.exports = __webpack_public_path__ + "img/swiper3.dd6b754c.png";